import { Container, Typography, Box, Paper, Divider } from "@mui/material";
import NextBreadcrumbs from "../component/NextBreadcrumbs";
import Page from "../component/Page";
import ReusableTabs from "../component/ReusableTabs";
import { useEffect, useState } from "react";

const LATEST_MAPS_BASE_URL = "https://dlq8zkk4s2twe.cloudfront.net";

const getGroupName = (groups, groupId) => groups?.[groupId] || groupId;

const getMapUrl = (path) => `${LATEST_MAPS_BASE_URL}/${path}-all.svg`;

export default function Drought() {
    const [prcpMaps, setPrcpMaps] = useState([]);
    const [smMaps, setSmMaps] = useState([]);

    useEffect(() => {
        fetch("/api/getLatestProductionMaps")
            .then(res => res.json())
            .then(json => {
                const files = Array.isArray(json.files) ? json.files : [];
                const arr = files
                    .filter(i => getGroupName(json.groups, i.group) === "Precipitation" && !i.title?.includes("Leaf"))
                    .map(i => ({ label: i.title, src: getMapUrl(i.path) }));
                const arr1 = files
                    .filter(i => getGroupName(json.groups, i.group) === "Soil Moisture")
                    .map(i => ({ label: i.title, src: getMapUrl(i.path) }));
                setPrcpMaps(arr);
                setSmMaps(arr1);
            });
    }, [])

    return (
        <Page>
            <img src="./background/drought.jpg" style={{ width: "100%", maxHeight: 250, objectFit: "cover", objectPosition: "center bottom" }}></img>
            <Container sx={{ py: 5 }}>
                <NextBreadcrumbs></NextBreadcrumbs>
                <Box>
                    <Typography variant="h3">Drought</Typography>
                    <Typography sx={{ textAlign: "justify", py: 3 }}>
                    </Typography>
                </Box>
                <Paper elevation={3}>
                    <ReusableTabs items={prcpMaps} panelHeight={600} imageProps={{ objectFit: "cover", height: "100%", width: "100%" }}></ReusableTabs>
                </Paper>
                {/* <Divider sx={{ my: 5 }}></Divider>
                <iframe src="https://waterwatch.usgs.gov/new/index.php?m=real&r=ky&w=map"
                    style={{ width: "100%", height: 650, minHeight: 650, border: 0 }}
                ></iframe>
                <Divider sx={{ my: 5 }}></Divider>
                <iframe src="https://waterwatch.usgs.gov/new/index.php?r=ky&m=dryw"
                    style={{ width: "100%", height: 650, minHeight: 650, border: 0 }}
                ></iframe> */}
                <Divider sx={{ my: 5 }}></Divider>
                <Paper elevation={3}>
                    <ReusableTabs items={smMaps} panelHeight={600} imageProps={{ objectFit: "cover", height: "100%", width: "100%" }}></ReusableTabs>
                </Paper>
            </Container>
        </Page>
    );
}